import * as FluxUtils from 'flux/utils';
import { AppDispatcher, DispatcherBaseAction } from '../dispatcher/AppDispatcher';
import { ActionConstants } from '../constants/ActionConstants';
import { GlobalHelper } from '../utils/GlobalHelper';

import core = egr.wcf.core;

interface SceneStoreState {
    basketIds: Array<string>;
    selectedElements: Array<core.mdl.SceneElement>;
    elementCount: number;
    savedSelection: Array<core.mdl.SceneElement>;
    viewHeight: number;
    viewWidth: number;
    viewerHeight: number;
    viewerWidth: number;
    activeView: HTMLDivElement | null;
    maximized: boolean;
    canUndo: boolean;
    canRedo: boolean;
    unsavedChanges: boolean;
}

class SceneStoreClass extends FluxUtils.ReduceStore<SceneStoreState, unknown> {
    public getInitialState(): SceneStoreState {
        return {
            basketIds: [],
            selectedElements: [],
            elementCount: 0,
            savedSelection: [],
            viewHeight: 0,
            viewWidth: 0,
            viewerHeight: 0,
            viewerWidth: 0,
            activeView: null,
            maximized: false,
            canUndo: false,
            canRedo: false,
            unsavedChanges: false,
        };
    }

    public architectureObjectSelected = (countCheck: number | null = null): boolean => {
        const state: SceneStoreState = this.getState();
        const architectureObjects: Array<core.mdl.SceneElement> = state.selectedElements.filter((selectedElement) => {
            return (
                selectedElement.category === core.mdl.ElementCategory.Wall ||
                selectedElement.category === core.mdl.ElementCategory.WallOpening
            );
        });
        if (countCheck == null) {
            return architectureObjects.length > 0;
        }
        return architectureObjects.length === countCheck;
    };

    public articleSelected = (): boolean => {
        return this.getState().selectedElements.length > 0;
    };

    public getCameraMode = (): core.view.CameraMode => {
        try {
            if (GlobalHelper.coreApp.viewer.activeView) {
                return GlobalHelper.coreApp.viewer.activeView.cameraControl.cameraMode;
            }
        } catch (e) {
            return core.view.CameraMode.Perspective;
        }
        return core.view.CameraMode.Perspective;
    };

    public wallSelected = (): boolean => {
        const state: SceneStoreState = this.getState();
        return (
            state.selectedElements.length === 1 &&
            state.selectedElements[0].category === core.mdl.ElementCategory.Wall
        );
    };

    public reduce(state: SceneStoreState, action: DispatcherBaseAction): SceneStoreState {
        // Note: this function should be `pure` -> we have to return a copy
        // of the current state if some property was changed

        switch (action.actionType) {
            case ActionConstants.ARTICLE_LIST_CHANGED:
                return jQuery.extend(
                    {},
                    state,
                    {elementCount: GlobalHelper.getSceneElementsCount()}
                );
            case ActionConstants.UPDATE_UNDO_REDO:
                return jQuery.extend(
                    {},
                    state,
                    action.value
                );
            case ActionConstants.SAVE_SELECTION:
                return jQuery.extend(
                    {},
                    state,
                    {savedSelection: action.value}
                );
            case ActionConstants.MAXIMIZE_SCENE:
                return jQuery.extend(
                    {},
                    state,
                    {maximized: action.value},
                    this.viewDimensions()
                );
            case ActionConstants.SET_VIEWER_DIMENSIONS:
                return jQuery.extend(
                    {},
                    state,
                    {viewerWidth: action.value.width, viewerHeight: action.value.height}
                );
            case ActionConstants.SET_ACTIVE_VIEW:
                return jQuery.extend(
                    {},
                    state,
                    this.viewDimensions()
                );
            case ActionConstants.UPDATE_SELECTION:
                return jQuery.extend({}, state, {
                    selectedElements: action.value.elements,
                    basketIds: action.value.ids
                });
            case ActionConstants.SET_UNSAVED_CHANGES:
                return jQuery.extend({}, state, {
                    unsavedChanges: action.value
                });
            case ActionConstants.RESET_PROJECT_RELATED_SETTINGS:
                return jQuery.extend({}, this.getInitialState(), this.viewDimensions());
            default:
                return state;
        }

    }

    private viewDimensions(): {viewerWidth: number, viewerHeight: number, viewWidth: number, viewHeight: number, activeView: HTMLDivElement} {
        let tWidth: number = 0;
        let tHeight: number = 0;

        const pView: HTMLDivElement = GlobalHelper.activeView.overlayDiv;
        if (pView) {
            tWidth = pView.clientWidth;
            tHeight = pView.clientHeight;
        }
        return {
            viewerWidth: GlobalHelper.coreApp.viewer.width,
            viewerHeight: GlobalHelper.coreApp.viewer.height,
            viewWidth: tWidth ? tWidth : 0,
            viewHeight: tHeight ? tHeight : 0,
            activeView: pView
        };
    }
}

export let SceneStore: SceneStoreClass = new SceneStoreClass(AppDispatcher);


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/stores/SceneStore.ts